import { render } from "./LanguagesComponent.vue?vue&type=template&id=30627b4c&scoped=true"
const script = {}

import "./LanguagesComponent.vue?vue&type=style&index=0&id=30627b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30627b4c"]])

export default __exports__